import axios, { AxiosRequestConfig } from 'axios';

const request = async <TResponse>(url: string, config?: RequestInit, defaultResponse?: TResponse): Promise<TResponse> => {
  const response = await fetch(url, config);

  if (response.status === 204) {
    if (defaultResponse !== undefined) {
      return defaultResponse;
    } else {
      throw new Error('204 response received, but no default response provided');
    }
  }
  return await response.json();
};

export const get = async <TResponse>(url: string): Promise<TResponse> => request<TResponse>(url, { headers: { 'Content-Type': 'application/json' } });

export const post = async <TBody, TResponse>(url: string, body: TBody) =>
  request<TResponse>(url, {
    method: 'POST',
    body: JSON.stringify(body),
    headers: { 'Content-Type': 'application/json' },
  });

export const put = async <TBody, TResponse>(url: string, body: TBody, defaultResponse?: TResponse) =>
  request<TResponse>(
    url,
    {
      method: 'PUT',
      body: JSON.stringify(body),
      headers: { 'Content-Type': 'application/json' },
    },
    defaultResponse,
  );

export const del = async <TBody, TResponse>(url: string, body?: TBody) =>
  request<TResponse>(url, {
    method: 'DELETE',
    body: JSON.stringify(body),
    headers: { 'Content-Type': 'application/json' },
  });

export const upload = async <TBody, TResponse>(url: string, body: TBody, config?: AxiosRequestConfig<TBody>) => {
  const response = await axios.post<string, TResponse, TBody>(url, body, {
    ...config,
    headers: { 'Content-Type': 'multipart/form-data', ...config?.headers },
  });
  return response;
};
